import Reminders from '../../components/reminder/Reminders';

export default function RemindersPage() {
  return <Reminders />;
}
